import {
  formatCurrency,
} from "helpers";
import { FleetVehicleOfferRentItemRow } from "services/api/fleet/vehicles/offers/types";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const FLEET_VEHICLE_OFFER_ITEMS_SEARCH_COLUMNS = (
  t: (key: string) => string,
  handleEditClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string
  ) => void,
  handleDeleteClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string
  ) => void
): Column[] => {


  return [
    {
      title: "admin.fleet.vehicle.offer.rent.item.added.code",
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <div className="text-md min-h-[40px] flex items-center font-light text-slate-500">{row.code}</div>
        );
      },
    },
    {
      title: "Vrsta",
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <div className="text-md font-light text-slate-500">{row.billingItemTypeName ?? "-"}</div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.offer.rent.item.added.name",
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <div className="text-md">{row.name}</div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.offer.rent.item.added.taxrate",
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <div className="text-md font-light text-slate-500">{row.taxRate} %</div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.offer.rent.item.added.quantity",
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <div className="text-md font-light text-slate-500">{row.quantity} {row.unitOfMeasureId ?? "kom"}</div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.offer.rent.item.added.pricewithouttax",
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <div className="text-md font-light text-slate-500">
            {formatCurrency.format(row.priceWithoutTax)}
          </div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.offer.rent.item.added.pricewithtax",
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <div className="text-md">
            {formatCurrency.format(row.priceWithTax)}
          </div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.offer.rent.item.added.discount",
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <div className="text-md font-light text-slate-500">
            {formatCurrency.format(row.discountAmount)}
          </div>
        );
      },
    },
    //  {
    //   title: "admin.fleet.vehicle.offer.rent.item.added.discount.percentage",
    //   field: "",
    //   type: ColumnTypes.custom,
    //   render: (row) => {
    //     return (
    //       <div className="text-md">{row.discountPercentage} %</div>
    //     );
    //   },
    // },
    {
      title: "admin.fleet.vehicle.offer.rent.item.added.total",
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <div className="text-md ">
            {formatCurrency.format(row.total)}
          </div>
        );
      },
    },
    {
      title: "",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleOfferRentItemRow) => {
        return (
          <>
            <ButtonMenu
              endIcon="/media/icons/more-dots.svg"
              cssClassName="h-full"
              variant="text"
            >
              <ButtonMenuItem
                startIcon="/media/icons/edit.svg"
                onClick={(e) => handleEditClick(e, row.id)}
              >
                Ažuriraj
              </ButtonMenuItem>
              <ButtonMenuItem
                startIcon="/media/icons/trash.svg"
                variant="remove"
                onClick={(e) => handleDeleteClick(e, row.id)}

              >
                Obriši
              </ButtonMenuItem>
            </ButtonMenu>
          </>
        );
      },
    },
  ];
};





export const FLEET_VEHICLE_OFFER_ITEMS_CHILD_SEARCH_COLUMNS = (
  t: (key: string) => string
): Column[] => [
    {
      title: "admin.fleet.vehicle.offer.rent.item.added.note",
      field: "note",
      type: ColumnTypes.string,
    },

  ];



